import './waves.scss';

const Chop = props => {
  const css = 'waves';

  return (
    <svg
      style={props.styles}
      className={`${css}__icon`}
      viewBox="0 0 38 72"
      height="72"
      width="38"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m31.03 72h-31.05v-.08z" fill="none" />
      <path
        d="m38 0v71.8h-.06c-15.13-6.3-13.09-92.95-15.65-61.45-2.73 33.57-20.03 60.45-22.29 61.57v-71.92z"
        fill="none"
      />
      <path d="m38 71.79v.21h-7l-31-.08c2.26-1.18 19.56-29.42 22.29-64.7 2.56-33.09.52 57.93 15.65 64.55z" />
    </svg>
  );
};

export default Chop;
